import React, { useState } from 'react'
import { Row, Col } from 'react-bootstrap'
import { COLORES } from '../../../../config/colores'
import { Button, IconButton } from '@material-ui/core'
import { EntityAutocomplete } from '../../../Forms/SharedComponents/containers'
import CancelIcon from '@material-ui/icons/Cancel'
import FindReplaceIcon from '@material-ui/icons/FindReplace'

function CampoExportadorRemito (props) {
  const { exportador = '' } = props
  const [showExportadores, setShowExportadores] = useState(false)

  return (
    <Row
      style={{
        margin: '2% 0 0 0',
        width: '100%',
        border: '1px solid',
        borderRadius: '22px',
        borderColor: COLORES.grey.light,
        padding: '8px'
      }}>
      <Col md={6} className='campos-remito-exportador'>
        <h6>Exportador:</h6>
        <h6><b>{exportador}</b></h6>
      </Col>

      { !showExportadores && <>
        <Col md={2} />
        <Col md={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            size='small'
            style={{
              color: !showExportadores ? COLORES.grey.dark : COLORES.grey.light,
              width: '100%'
            }}
            onClick={() => { setShowExportadores(true) }}
            disabled={showExportadores}
          >
            <FindReplaceIcon style={{ color: !showExportadores ? COLORES.grey.dark : COLORES.grey.light }} />
                        Cambiar exportador
          </Button>
        </Col></>
      }
      {showExportadores &&
      <Col md={6} style={{ display: 'flex', justifyContent: 'flex-end' }} >
        <EntityAutocomplete
          name='exportador'
          label=' '
          entity='exportador'
          className='autocomplete-exportador-bruto'
          placeholder='Exportador - 19999999991'
        />
        <div
          style={{
            display: 'flex',
            padding: 0,
            alignItems: 'center'
          }}
        >
          <IconButton onClick={() => { setShowExportadores(false) }} style={{ outlined: 'none' }}>
            <CancelIcon style={{ color: COLORES.grey.medium }} />
          </IconButton>
        </div>
      </Col>
      }

    </Row>
  )
}

export default CampoExportadorRemito
